import { render, staticRenderFns } from "./AwaitApproval.vue?vue&type=template&id=572bfbe1"
import script from "./AwaitApproval.vue?vue&type=script&lang=js"
export * from "./AwaitApproval.vue?vue&type=script&lang=js"
import style0 from "./AwaitApproval.vue?vue&type=style&index=0&id=572bfbe1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports